import { render, staticRenderFns } from "./Yinhua.vue?vue&type=template&id=54c11b50&scoped=true"
import script from "./Yinhua.vue?vue&type=script&lang=js"
export * from "./Yinhua.vue?vue&type=script&lang=js"
import style0 from "./Yinhua.vue?vue&type=style&index=0&id=54c11b50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c11b50",
  null
  
)

export default component.exports